import { createApiHandler } from 'react-lib/dist/agent-es';
import { keycloakConfig } from './keycloak';

export * from 'react-lib/dist/agent-es';

export const baseUrl = '/api';
const apiConfig = {
  baseURL: baseUrl,
  config: {
    redirect: '/',
  },
};
export const api = createApiHandler(apiConfig, null, null, keycloakConfig);

export default {
  api,
  apiConfig,
};
